import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
// import { CityListWrapper } from '../../master/city-management/city-list/CityList'

const rolePermissionBreadcrumbs: Array<PageLink> = [
  {
    title: 'Role Permission Management',
    path: '/apps/master/role-permission-management/role-permission',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const RolePermissionPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='role-permission'
          element={
            <>
              <PageTitle breadcrumbs={rolePermissionBreadcrumbs}>Role Permission list</PageTitle>
               {/* <CityListWrapper />  */}
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/master/role-permission-management/role-permission' />} />
    </Routes>
  )
}
export default RolePermissionPage
